<template>
  <div>
    <div class="suc-main" v-if="$route.query.shared_uid">
      <img class="bg" src="@a/ceping79/zlcg-bg.png" alt="" />
      <img class="cle" src="@a/ceping79/zlcg.png" alt="" />
      <p   class="small">
        你已成功帮助好友回归星球<br />继任购物星球最高领袖 从此购物不剁手
      </p>
      <div  class="qr">
        <div id="qrcode" style="display: none;"></div>
        <!-- 上面这个用来生成二维码，隐藏掉，下面这个放置转换后的图片 -->
        <div id="myQRCode"></div>
      </div>
      <p   class="small2">快测测你属于哪个星球吧</p>
    </div>
    <div v-else class="ceping79-main">
      <div class="header">
        <div class="logot">
          <div class="top">生涯</div>
          <div class="bottom">研习社</div>
        </div>
        <div class="right">生涯研习社</div>
      </div>
      <img class="qrcode" src="@a/ceping79/syyxs.jpg" alt="" />
      <p class="text">长按识别二维码关注此公众号</p>
    </div>
  </div>
</template>

<script>
import {
  ceping79_support_user,
  ceping79_check_support_user,
  ceping_event,
} from "@/api/measurement";
import { isMain } from "@u/tools";
export default {
  data() {
    return {
      cid: 79
    }
  },
  methods: {
    // 初始化数据
    pullData() {
      let q = this.$route.query;
      if (q.shared_uid) {
        //调用加载中
        this.$emit("loadingHandle", true, "拼命加载中...");
        ceping79_check_support_user({
          share_uid: q.shared_uid,
        }).then((data) => {
          if (data.code == "10002") {
            //关闭加载中
            this.$emit("loadingHandle", false);
            this.$toast(data.msg);
            return;
          }
          if(data.status==1){
            setTimeout(()=>{
              var hideQRCode = document.getElementById("qrcode"),
                  myQRCode = document.getElementById("myQRCode"),
                  image = new Image();

              var qrcode = new QRCode(hideQRCode, {
                  width : 90,
                  height : 90
              });
              qrcode.makeCode(`https://open.xjy.cn/${isMain()?'main':'test'}/ceping79`);
              // 获取canvas元素转成 img 
              image.src = hideQRCode.firstChild.toDataURL("image/png");    
              myQRCode.appendChild(image); // 放到页面

                // let qrcode = new QRCode(document.getElementById("qrcode"), {
                //     width: "90",
                //     height: "90",
                // });
                // qrcode.makeCode(`https://open.xjy.cn/${isMain()?'main':'test'}/ceping79`);
            },200);
          }else{
            this.$router.push({path:'/ceping79',query:this.$route.query});
          }
          
          ceping_event({ lead_sid: this.$route.query.lead_sid,
            cid: this.cid,
            event: 'ViewDetails',
          }).then(res=>{
            // 页面访问统计
          });
          //关闭加载中
          this.$emit("loadingHandle", false);
        });
      }
      if (q.share_uid) {
        //调用加载中
        this.$emit("loadingHandle", true, "拼命加载中...");
        ceping79_support_user({
          share_uid: q.share_uid,
        }).then((data) => {
          if (data.code == "10002") {
            //关闭加载中
            this.$emit("loadingHandle", false);
            this.$toast(data.msg);
            return;
          }

          //关闭加载中
          this.$emit("loadingHandle", false);
        });
      }
    },
  },
  created() {
    this.pullData();
  },
};
</script>

<style lang="scss" scoped>
// 主力成功
.suc-main {
  text-align: center;
  img.bg {
    position: absolute;
    width: 100%;
    z-index: -1;
    top: 0;
    left: 0;
  }
  .cle {
    margin: 138px auto 20px;
    width: 356px;
    height: 326px;
  }
  .small {
    font-size: 30px;
    color: #ffffff;
    line-height: 58px;
    margin-bottom: 220px;
  }
  .qr{
      text-align: center;
      // border-radius: 15px;
      // background-color: #ffffff;
      margin: 0px auto 30px;
      padding: 15px;
      width: 210px;
      #qrcode{
          margin: 0 auto;
          display: block;
          text-align: center;
          img{
            display: block;
            margin: 0 auto;
          }
      }
  }
  .small2{
      font-size: 28px;
      color: #ffffff;
  }
}

// 关注二维码
.ceping79-main {
  border-radius: 15px;
  background-color: #ffffff;
  padding: 40px 30px;
  margin: 100px 30px;
  text-align: center;
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 80px;
    .logot {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #0199fe;
      text-align: center;
      color: #ffffff;
      padding: 15px 10px;
      .top {
        font-size: 42px;
        letter-spacing: 4px;
      }
      .bottom {
        font-size: 22px;
        letter-spacing: 10px;
      }
    }
    .right {
      margin-left: 30px;
      font-size: 30px;
      color: #333333;
      letter-spacing: 4px;
    }
  }
  .qrcode {
    width: 500px;
    margin-bottom: 50px;
  }
  .text {
    font-size: 34px;
    color: #333333;
    text-align: center;
    margin-bottom: 50px;
  }
}
</style>

<style lang="scss">
.qr{
  #myQRCode{
    margin: 0 auto;
    display: block;
    text-align: center;
    min-width: 210px;
    img{
      display: block;
      margin: 0 auto;
      border: 15px solid #ffffff;
      border-radius: 15px;
    }
  }
  }
</style>